import { memo } from 'react';
const ContainerBody = ({ children,onScroll,targetDiv, ...props }) => {
    return (
        <div {...props} onScroll={onScroll} ref={targetDiv} className='stickysidemenu-content'>
            {children}
        </div>
    )

}

export default memo(ContainerBody);